<template>
  <div>
    <template v-for="node in nodes" :key="node.id">
      <div
        :class="[
          'tree-selector-node py-1.5 px-2 rounded text-sm flex items-center gap-1.5 transition-colors',
          selectedId === node.id ? 'bg-primary-50 text-primary-700' : 'hover:bg-slate-50 text-slate-700',
          isUnselectable(node) ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'
        ]"
        :style="{ paddingLeft: `${8 + depth * 16}px` }"
        @click="handleClick(node)"
      >
        <el-icon :size="14" class="shrink-0">
          <FolderOpened v-if="node.children?.length" />
          <Folder v-else />
        </el-icon>
        <span class="truncate">{{ node.name }}</span>
        <span v-if="isDisabled(node)" class="text-[10px] px-1 rounded bg-red-50 text-red-600">禁用</span>
        <span v-else-if="node.permissionLevel !== 'MANAGE'" class="text-[10px] px-1 rounded bg-slate-100 text-slate-500">只读</span>
        <el-icon v-if="selectedId === node.id" :size="14" class="ml-auto text-primary-500"><Check /></el-icon>
      </div>
      <FolderTreeSelector
        v-if="node.children?.length"
        :nodes="node.children"
        :selected-id="selectedId"
        :exclude-id="excludeId"
        :depth="depth + 1"
        @select="$emit('select', $event)"
      />
    </template>
  </div>
</template>

<script setup>
import { Folder, FolderOpened, Check } from '@element-plus/icons-vue'

const props = defineProps({
  nodes: { type: Array, default: () => [] },
  selectedId: { type: [Number, String], default: null },
  excludeId: { type: [Number, String], default: null },
  depth: { type: Number, default: 0 }
})

const emit = defineEmits(['select'])

function handleClick(node) {
  if (isUnselectable(node)) return
  emit('select', node.id)
}

function isUnselectable(node) {
  return node.pathOnly || node.id === props.excludeId || isDisabled(node) || node.permissionLevel !== 'MANAGE'
}

function isDisabled(node) {
  return node.status === 0 || node.status === 'DISABLED'
}
</script>
